// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__303nn","content":"styles_content__2OBjI","tableWrap":"styles_tableWrap__3Spvn"};